<template>
  <b-sidebar
    id="sidebar-right-user"
    title="Детальная информация о сотруднике"
    right
    backdrop
    shadow
    no-close-on-route-change
    no-close-on-backdrop
    width="65em"
    backdrop-variant="dark"
  >
    <table class="table table-borderless table-hover" v-if="detailedItem.id">
      <tbody>
        <tr>
          <td class="table-title-details">Имя: </td>
          <td>{{ refactorFullName(detailedItem.name, 1) }}</td>
        </tr>
        <tr>
          <td class="table-title-details">Фамилия: </td>
          <td>{{ refactorFullName(detailedItem.name, 0) }}</td>
        </tr>
        <tr>
          <td class="table-title-details">Отчество: </td>
          <td>{{ refactorFullName(detailedItem.name, 2) }}</td>
        </tr>
        <tr>
            <td class="table-title-details">Добавлен в система: </td>
            <td>{{ detailedItem.created_at }}</td>
        </tr>
        <tr>
            <td class="table-title-details">ИС окончен: </td>
            <td>{{ detailedItem.trial_period_ends_at }}</td>
        </tr>
        <tr>
          <td class="table-title-details">ID: </td>
          <td>{{ detailedItem.id }}</td>
        </tr>
        <tr>
            <td class="table-title-details">Bitrix ID: </td>
            <td>{{ detailedItem.bitrix_user_id ? detailedItem.bitrix_user_id : '-' }}</td>
        </tr>  
        <tr>
          <td class="table-title-details">Операционный директор: </td>
          <td>{{ detailedItem.is_operation_director ? 'Да' : 'Нет' }}</td>
        </tr>
        <tr>
          <td class="table-title-details">Уволен: </td>
          <td>{{ detailedItem.fired ? 'Да' : 'Нет' }}</td>
        </tr>
        <tr>
          <td class="table-title-details">Должность: </td>
          <td v-if="detailedItem.position">{{ detailedItem.position }}</td>
          <td v-else>Не назначена</td>
        </tr>
        <tr>
          <td class="table-title-details">Телефон: </td>
          <td>{{ detailedItem.phone }}</td>
        </tr>
        <tr>
          <td class="table-title-details">E-mail: </td>
          <td>{{ detailedItem.email }}</td>
        </tr>
        <tr v-if="detailedItem.segments_transport_company && detailedItem.segments_transport_company.length > 0">
          <td class="table-title-details">Транспортные сегменты и страны: </td>
          <td>
            <div v-for="segment in detailedItem.segments_transport_company" :key="`segment_${segment.reference_property_id}`" class="mb-3">
              <div class="font-weight-bold">
                {{ getTransportSegmentName(segment.reference_property_id) }}
              </div>
              <div v-if="segment.countries && segment.countries.length > 0" class="mt-1">
                <div class="d-flex flex-wrap">
                  <span 
                    v-for="(countryId, index) in segment.countries" 
                    :key="`country_${countryId}`"
                    class="badge mr-1 mb-1"
                  >
                    {{ getCountryName(countryId) }}
                  </span>
                </div>
              </div>
              <div v-else class="ml-3 mt-1">
                <small class="text-muted">Страны не назначены</small>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="my-5">
      <h5>Компании, привязанные к менеджеру</h5>    
      <div class="d-flex mt-5" style="flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-around;
        align-items: center;
        align-content: center;">
        <div
          v-for="(element, index) in analytic.companies"
          :title="element.name"
          :key="index"
          @click="changeOpenedCompany(index)"
          style="cursor:pointer;"
        >
          <div class="text-center" v-if="!loading">
            <span class="bigNumber">{{ element.sum }}</span>
            <div>{{ element.name }}</div>
          </div>
          <div class="font-size-14" v-if="loading"><b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" class="mr-2" animation="spin"></b-icon>Обновляем...</div>
        </div>
      </div>
      <hr>
      <div class="mt-3" v-if="analytic.companies && analytic.companies[company_opened] && analytic.companies[company_opened].list.length > 0">
        <h6>Компании в списке:</h6>
        <div
          v-for="(company, c_index) in analytic.companies[company_opened].list"
        >
          {{ c_index + 1 }}: <span class="sidebar-link" @click="openCompanySidebar(company.id)">{{ company.name }}</span> / {{ company.inn }}
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { openCompanySidebar } from '@/mixins/openCompanySidebar';
import { API_USER_ANALYTIC } from '@/constants';

export default {
  props: {
    detailedItem: {
      type: Object,
      require: true
    }
  },
  mixins: [openCompanySidebar],
  watch: {
    detailedItem: {
        deep: true,
        handler(detailedItem) {
          if (detailedItem.id) {
            this.fetchAnalytic();
          }
        },
    }, 
  },  
  data() {
    return {
        loading: false,
        analytic: {},
        company_opened: 'all'
    }
  },
  mounted() {
  },
  methods: {
    refactorFullName(name, part) {
      return name.split(' ')[part] || '  —  ';
    },
    changeOpenedCompany(key_name) {
      this.company_opened = key_name;
    },
    fetchAnalytic() {
      this.loading = true;

      axios.get(`${API_USER_ANALYTIC}/` + this.detailedItem.id).then(({ data }) => {
          this.analytic = data;
          this.loading = false;
      });       
    },
    getTransportSegmentName(reference_property_id) {
      const groupedProperties = this.$store.getters.GROUPED_REFERENCE_PROPERTIES;
      if (groupedProperties && groupedProperties[86]) {
        const property = groupedProperties[86].find(item => item.id === reference_property_id);
        return property ? property.name : `Сегмент ${reference_property_id}`;
      }
      return `Сегмент ${reference_property_id}`;
    },
    getCountryName(countryId) {
      const groupedProperties = this.$store.getters.GROUPED_REFERENCE_PROPERTIES;
      if (groupedProperties && groupedProperties[20]) {
        const property = groupedProperties[20].find(item => item.id === countryId);
        return property ? property.name : `Страна ${countryId}`;
      }
      return `Страна ${countryId}`;
    }
  },
}
</script>